type ContentType = 'application/pdf' | 'image/jpeg' | 'image/png';

export const uploadFileToS3 = async (
  url: string,
  file: File,
  fileType: ContentType,
) => {
  const response = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': fileType },
    body: file,
  });

  if (!response.ok) {
    throw new Error('Failed to upload file');
  }
};

export const uploadImagesToS3 = async (
  presignedItems: PolicyImagePresignedUrlItem[],
  files: File[],
): Promise<void> => {
  await Promise.all(
    presignedItems.map((item, index) => {
      const file = files[index];
      const contentType = file.type as ContentType;
      return uploadFileToS3(item.url, file, contentType);
    }),
  );
};
